<app-modal #modal>

  <span title>{{"Price List"|translate}}</span>

  <div body class="list-group">

    @if(priceList().length > 0){
    @for (price of priceList(); track $index) {
    <div class="price-row">
      <div>{{price.priceList}}</div>
      <div>
        {{sharedService.getPriceLabel(price)}}

        @if(price.tax){
        <div class="taxes">{{('Including Taxes'|translate)}}</div>
        }@else {
        <div class="taxes">{{('Excluding Taxes'|translate)}}</div>
        }
      </div>
    </div>
    }
    }@else {
    <app-placeholder [message]="'The Price List is empty'|translate"></app-placeholder>
    }

  </div>

</app-modal>
